<template>
    <nuxt-link
        class="search-result-text pt-3 pb-3"
        :to="$locale.path('reward-info')"
        :title="item.title"
        rel="nofollow"
    >
        <div class="d-flex title-container">
            <UIImage
                :resource="true"
                lazy
                src="images/general/article-image-search-page.png"
                fit="cover"
                alt="Dundle logo image for pages"
                :width="340"
                :responsive-widths="[100, 120, 150]"
            />
            <div class="d-flex title-container flex-column justify-content-center mr-3">
                <div class="title font-weight-bold">{{ translateParams(item.title) }}</div>
                <p class="intro mb-0">{{ translateParams(item.description) }}</p>
            </div>
            <div class="align-items-center d-none d-md-flex">
                <UIButton variant="default">
                    {{ translate('button.visit') }}
                </UIButton>
            </div>
        </div>
    </nuxt-link>
</template>

<script>
import { UIButton } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: { UIButton },
    mixins: [TranslationMixin],
    props: ['item'],
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/imageUtils.scss';

.search-result-text {
    display: flex;
    background-color: #fff;
    border-bottom: 1px solid $color-grey-3;
    color: $color-text;
    button {
        min-width: 150px;
    }
    .page-image {
        display: flex;
        align-self: center;
        width: 110px;
        min-width: 110px;

        @media screen and (max-width: 768px) {
            width: 100px;
            min-width: 100px;
        }
        @include calculate-image-border-radius(10%);
    }

    @media screen and (max-width: 768px) {
        padding: 0 15px;
        border-top: 10px solid $color-grey-1;
    }

    &:hover {
        background-color: $color-primary-light;
        text-decoration: none;
    }
    .intro {
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
<i18n src="@dundle/locale/data/buttons.json"></i18n>
